import Vercel from '@gonfalon/img/icons/vercel.svg';
import { Tag, TagGroup, TagList, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import styles from './VercelEnvironmentIndicator.module.css';

interface Props {
  variant?: 'tag' | 'icon';
}

function VercelIcon() {
  return (
    <span className={styles.icon}>
      <Vercel width={12} height={12} />
    </span>
  );
}

export function VercelEnvironmentIndicator({ variant = 'icon' }: Props) {
  if (variant === 'icon') {
    return <VercelIcon />;
  } else if (variant === 'tag') {
    return (
      <TooltipTrigger>
        <TagGroup aria-label="platform">
          <TagList>
            <Tag size="small" variant="default" className={styles.tag} textValue="Vercel">
              <VercelIcon />
              Vercel
            </Tag>
          </TagList>
        </TagGroup>
        <Tooltip>This environment is linked to Vercel</Tooltip>
      </TooltipTrigger>
    );
  }
}
